import { Link, graphql } from 'gatsby';
import React, {useEffect, useState } from 'react';
import { SRLWrapper } from 'simple-react-lightbox';
import { Swiper, SwiperSlide } from 'swiper/react';
import Cta from '~/components/ContentFactory/Cta';
import CustomCursor from '~/components/CustomCursor';
import Image from '~/components/Dynamic/Image';
import Layout from '~/components/Layout';
import Seo from '~/components/SEO';
import ArrowRight from '~/icons/white-arrow.svg';
import renderLink from '~/utils/render-link';
import useStoryblok from '~/utils/storyblok-service';

const PortfolioPage = ({ data, location, pageContext }) => {
  const { portfolioItems } = data;

  const items = portfolioItems.nodes.map((item, i) => {
    const itemContent = JSON.parse(item.content);
    return {
      i,
      name: item.name,
      image: itemContent.heroImage,
      gallery: itemContent.gallery,
      full_slug: item.full_slug
    }
  });

  const activeItemIndex = items.filter(item => item.name === data.storyblokEntry.name).pop().i || 0;


  const spans = [
    'col-span-6 md:col-span-4',
    'col-span-6 md:col-span-8',
    'col-span-6 lg:col-span-4',
    'col-span-6 lg:col-span-4',
    'col-span-12 lg:col-span-4',
    'col-span-12 lg:col-span-6',
    'col-span-6 lg:col-span-3',
    'col-span-6 lg:col-span-3',
    'col-span-12 lg:col-span-8',
    'col-span-6 lg:col-span-4',
    'col-span-6 lg:col-span-4',
    'col-span-6 lg:col-span-4',
    'col-span-6 lg:col-span-4',
  ];

  const swiperInst = React.useRef(null);
  const [active, setActive] = useState(0);

  const story = useStoryblok(data.storyblokEntry, location);

  useEffect(()=>{
    swiperInst?.current?.swiper?.slideTo(activeItemIndex+1);
  }, []);

  return (
    <Layout headerColor="black" hideFooterCta hideSecondaryFooterCta locale={pageContext.locale}>
      <Seo {...story?.content?.seo} lang={story.lang} pageContext={pageContext} />

      <section className="pt-48 pb-28 -mt-20 bg-black text-white relative">
        <div className="container relative">
          <Swiper

            ref={swiperInst}
            className="px-14 max-w-[80%] mx-auto overflow-visible"
            style={{ overflow: 'visible' }}
            loop
            simulateTouch={false}
          >
            {items.map((item, i) => (
              <SwiperSlide key={`swiper-${i}`} className="">
                <Link to={renderLink(item.full_slug)} className="block w-full px-2 md:px-6 relative group" onClick={() => setActive(i)}>
                  <div className="aspect-w-3 aspect-h-2">
                    <div
                      className={`w-full h-full !absolute filter grayscale opacity-30 group-hover:grayscale-0 group-hover:opacity-80 transition-all ${
                        active === i && 'opacity-[80] grayscale-0'
                      }`}
                    >
                      <Image blok={item.image} className="object-cover h-full w-full" />
                    </div>
                  </div>
                  <div className="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center">
                    <div className="max-w-32 text-center mx-auto relative">
                      <h2 className="text-secondary-h1 text-[150px]">{item.name}</h2>
                    </div>
                  </div>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="flex mt-4 md:mt-0 absolute -bottom-20 left-2 right-2">
            <button className="p-1 outline-none" onClick={() => swiperInst.current.swiper.slidePrev()}>
              <div className="w-12 h-12 flex justify-center items-center">
                <img src={ArrowRight} className="transform -rotate-180 -ml-1" alt="" />
              </div>
            </button>
            <button className="p-1 outline-none ml-auto" onClick={() => swiperInst.current.swiper.slideNext()}>
              <div className="w-12 h-12  flex justify-center items-center">
                <img src={ArrowRight} className="transform ml-1" alt="" />
              </div>
            </button>
          </div>
        </div>
      </section>

      <section>

        <div className="container max-w-none xl:max-w-[1320px] sm:px-10 py-10 xl:py-14">
          <SRLWrapper>
            <div className="grid gap-8 md:gap-10 xl:gap-12 grid-cols-12">
              {story?.content?.gallery?.map((item, i) => (
                <div
                  key={`portfolio-${i}`}
                  className={`h-[34vw] md:h-[30vw] xl:h-[22rem] relative group cursor-pointer ${spans[i]}`}
                >
                  <CustomCursor content={<img src={ArrowRight} alt="" />} className="h-full w-full">
                    <a href={item.filename} className="h-full w-full !absolute inset-0 filter group-hover:blur-[1px] transition-all  duration-300">
                      <img src={item.filename} className="object-cover h-full w-full" />
                    </a>
                  </CustomCursor>
                </div>
              ))}
            </div>
          </SRLWrapper>
        </div>
      </section>

      <div className="my-28">
        <Cta
          className=""
          title="Get BOOM Factory to shoot and deliver your brand's visuals!"
          linkUrl="/contact"
          linkText="Contact Us"
        />
      </div>
    </Layout>
  );
};

export default PortfolioPage;


export const query = graphql`
  query FactoryPortfolioQuery($id: String!, $lang: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }

    portfolioItems: allStoryblokEntry(filter: { field_component: { eq: "factoryPortfolio" }, lang: { eq: $lang } }) {
      nodes {
        id
        name
        content
        slug
        uuid
        full_slug
      }
    }
  }
`;
